import { createContext, useCallback, useContext, useState } from 'react';
import { C, RADIUS } from '../theme';

const Ctx = createContext({ open: () => {} });

export function useComingSoon() {
  return useContext(Ctx);
}

export function ComingSoonProvider({ children }) {
  const [info, setInfo] = useState(null);
  const open = useCallback((title, description) => setInfo({ title, description }), []);
  const close = useCallback(() => setInfo(null), []);

  return (
    <Ctx.Provider value={{ open }}>
      {children}
      {info && (
        <div
          onClick={close}
          role="dialog"
          aria-modal="true"
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(44,36,32,0.45)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            padding: 24,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: C.card,
              border: `1px solid ${C.border}`,
              borderRadius: RADIUS.lg,
              padding: '24px 28px 22px',
              maxWidth: 380,
              width: '100%',
              boxShadow: '0 12px 40px rgba(0,0,0,0.18)',
              textAlign: 'center',
              fontFamily: 'inherit',
            }}
          >
            <div style={{ fontSize: 17, fontWeight: 500, color: C.textDark, marginBottom: 6 }}>
              {info.title} — coming soon
            </div>
            <div style={{ fontSize: 13, color: C.textMuted, lineHeight: 1.5, marginBottom: 20 }}>
              {info.description || "Not yet available."}
            </div>
            <button
              type="button"
              onClick={close}
              style={{
                padding: '8px 20px',
                borderRadius: RADIUS.md,
                background: C.orange,
                color: '#fff',
                border: 'none',
                fontSize: 13,
                fontWeight: 500,
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}
            >
              Got it
            </button>
          </div>
        </div>
      )}
    </Ctx.Provider>
  );
}
